const CLINIC_STARTING_HOUR = 7;
const CLINIC_ENDING_HOUR = 21;
const SLOT_HEIGHT = 24;
const EXTENDED_SLOT_HEIGHT = 8;
const SLOT_TIME = 15;
const SLOT_SNAP = SLOT_HEIGHT / 3;
const SLOT_TIME_SNAP = SLOT_TIME / 3;
const TIME_FORMAT = "HH:mm";
const HEADER_HOUR_FORMAT = "H:mm";
const DATE_FORMAT = "yyyy-MM-dd";
const COLUMN_WIDTH = 120;
const COLUMN_MARGIN = 4;
const ADD_BUTTON_COLUMN_WIDTH = 16;
const COLUMN_TOTAL_WIDTH = COLUMN_WIDTH + 2 * COLUMN_MARGIN;
const EXTENDED_COLUMN_WIDTH = 178;
const EXTENDED_COLUMN_TOTAL_WIDTH = EXTENDED_COLUMN_WIDTH + 2 * COLUMN_MARGIN;
const MAX_STACKED_ITEMS_TO_SHOW = 2;
const MAX_STACKED_EXTENDED_ITEMS_TO_SHOW = 8;
export {
  ADD_BUTTON_COLUMN_WIDTH,
  CLINIC_ENDING_HOUR,
  CLINIC_STARTING_HOUR,
  COLUMN_MARGIN,
  COLUMN_TOTAL_WIDTH,
  COLUMN_WIDTH,
  DATE_FORMAT,
  EXTENDED_COLUMN_TOTAL_WIDTH,
  EXTENDED_COLUMN_WIDTH,
  EXTENDED_SLOT_HEIGHT,
  HEADER_HOUR_FORMAT,
  MAX_STACKED_EXTENDED_ITEMS_TO_SHOW,
  MAX_STACKED_ITEMS_TO_SHOW,
  SLOT_HEIGHT,
  SLOT_SNAP,
  SLOT_TIME,
  SLOT_TIME_SNAP,
  TIME_FORMAT
};
